module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_2_3_.57d9b5df.png";